import { commonComponentValues, commonValues, dynamicComponentValues } from './commonValues'

const icon = {
  500: '#ffffff'
}

const gray = {
  100: '#f8f9fa',
  200: '#e9ecef',
  300: '#dee2e6',
  400: '#ced4da',
  500: '#adb5bd',
  600: '#6c757d',
  700: '#495057',
  800: '#343a40',
  900: '#212529'
}

export default {
  ...commonValues,
  palette: {
    mode: 'dark',
    primary: {
      light: '#78dca7',
      main: '#3cc480',
      // main: base[500],
      dark: '#278a59',
      contrastText: '#fff'
    },
    secondary: {
      light: '#efb17c',
      main: '#d38c4e',
      dark: '#a2662e',
      // light: '#ecd08e',
      // main: '#eeb53e',
      // dark: '#c58e14',
      contrastText: '#fff'
    },
    third: {
      // light: third[300],
      main: '#000000',
      // dark: third[700],
      contrastText: '#ffffff'
    },
    gray: {
      light: gray[300],
      main: gray[500],
      dark: gray[700],
      contrastText: '#fff'
    },
    icon: {
      main: icon[500]
    },
    notification: {
      main: 'rgba(255,0,255,0.8)'
    },
    background: {
      default: '#000000'
    },
    text: {
      primary: gray[300],
      secondary: gray[500]
    }
  },
  components: {
    ...commonComponentValues,
    ...dynamicComponentValues(false)
  }
}

/*
#2b6173
#4f7c8b
#7396a3

#e8f569
#e6f283
#e5ef9d
 */
